import React from 'react'
import { Container } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import PermissionWrapper from '../auth/PermissionWrapper';
import LandingAdmin from '../components/LandingAdmin/LandingAdmin';
import LandingDefault from '../components/LandingDefault/LandingDefault';

class Help extends React.Component {

    render = () => {
        this.props.info('Help.js/render');
        return (
            <Container>
To do work here
            </Container>
        )
    }
}

export default Help;